import {Component} from 'react'
import {Route, Switch, Redirect} from 'react-router-dom'

import LoginForm from './components/LoginForm'
import Home from './components/Home'
import Products from './components/Products'
import ProductItemDetails from './components/ProductItemDetails'
import Cart from './components/Cart'
import NotFound from './components/NotFound'
import ProtectedRoute from './components/ProtectedRoute'
import CartContext from './context/CartContext'
import WhishList from './components/whishList'

import './App.css'

class App extends Component {
  state = {
    cartList: [],
    wishList: [],
  }

  addCartItem = product => {
    const {cartList} = this.state
    const addItem = cartList.filter(each => each.id === product.id)
    if (addItem.length === 0) {
      this.setState(prevState => ({cartList: [...prevState.cartList, product]}))
    } else {
      this.incrementCartItemQuantity(product.id)
    }
  }

  removeAllCartItems = () => {
    this.setState({cartList: []})
  }

  removeCartItem = id => {
    const {cartList} = this.state
    const removeItem = cartList.filter(each => each.id !== id)
    this.setState({cartList: removeItem})
  }

  incrementCartItemQuantity = id => {
    const {cartList} = this.state

    const update = cartList.map(eachCartItem => {
      if (id === eachCartItem.id) {
        const updatedQuantity = eachCartItem.quantity + 1
        return {...eachCartItem, quantity: updatedQuantity}
      }
      return eachCartItem
    })

    this.setState({cartList: update})
  }

  addWishList = item => {
    this.setState(prevState => ({wishList: [...prevState.wishList, item]}))
  }

  decrementCartItemQuantity = id => {
    const {cartList} = this.state

    const update = cartList.map(eachCartItem => {
      if (id === eachCartItem.id) {
        const updatedQuantity = eachCartItem.quantity - 1
        return {...eachCartItem, quantity: updatedQuantity}
      }
      return eachCartItem
    })

    const productObject = cartList.find(each => each.id === id)
    if (productObject.quantity > 1) {
      this.setState({cartList: update})
    } else {
      this.removeCartItem(id)
    }
  }

  render() {
    const {cartList, wishList} = this.state

    return (
      <CartContext.Provider
        value={{
          cartList,
          wishList,
          addCartItem: this.addCartItem,
          removeCartItem: this.removeCartItem,
          removeAllCartItems: this.removeAllCartItems,
          incrementCartItemQuantity: this.incrementCartItemQuantity,
          decrementCartItemQuantity: this.decrementCartItemQuantity,
          addWishList: this.addWishList,
        }}
      >
        <Switch>
          <Route exact path="/login" component={LoginForm} />
          <ProtectedRoute exact path="/" component={Home} />
          <ProtectedRoute exact path="/products" component={Products} />
          <ProtectedRoute
            exact
            path="/products/:id"
            component={ProductItemDetails}
          />
          <ProtectedRoute exact path="/cart" component={Cart} />
          <ProtectedRoute exact path="/whishList" component={WhishList} />
          <Route path="/not-found" component={NotFound} />
          <Redirect to="not-found" />
        </Switch>
      </CartContext.Provider>
    )
  }
}

export default App
